import React from "react";
import Select from "react-select";
import DropDownStyles from "./dropdownStyles";
import { useLengthUnits, normalizeUnitsData } from "../../hooks/queries/useLengthUnits";

const LengthUnitDropDownSelection = ({ onChange, selectedValue }) => {
  const { data } = useLengthUnits();
  const lengthUnit = normalizeUnitsData(data);

  const LengthUnitOptions = lengthUnit.map((unit) => ({
    value: Number(unit.id),
    label: unit.Name,
  }));

  return (
    <Select
      value={LengthUnitOptions.find((option) => option.value === Number(selectedValue)) || null}
      onChange={onChange}
      options={LengthUnitOptions}
      styles={DropDownStyles}
      placeholder="Select Length Unit"
      isClearable={true}
    />
  );
};

export default LengthUnitDropDownSelection;
